import { ButtonLink, Stack } from 'component-library';

import { Icon } from '@/components/widgets/a/Icon/Icon';

type LinkCardProps = {
  to: string;
  icon: string;
  title: string;
};

export const LinkCard = ({ to, icon, title }: LinkCardProps) => {
  return (
    <ButtonLink
      className='rounded-3xl border border-neutral-black-12 p-6 transition-all duration-200 gap-2 w-[380px] h-[320px] hover:border-primary-hover hover:bg-neutral-hover text-neutral-black-40'
      to={to}
      variant='text'
    >
      <Stack spacing={4} center centerMain>
        <Stack center centerMain>
          <Icon icon={icon} className='text-7xl' />
        </Stack>
        <Stack spacing={2}>
          <span className='typography-h4 whitespace-pre-wrap text-neutral-black-80'>{title}</span>
        </Stack>
      </Stack>
    </ButtonLink>
  );
};
